(function () {

    "use strict";

    function toolbarController() {

    }

    toolbarController.$inject = [];

    angular.module("sphforms.main")
        .component("sphFormsToolbar", {
            controller: toolbarController,
            bindings: {
                title: "="
            },
            templateUrl: "modules/main/components/ui/toolbar/toolbar.template.html"
        });

}());
